"use client";
import { FC, useContext } from "react";
import classNames from "classnames";

import { HeaderContext, IHeaderContext } from "context/HeaderContext";

import s from "./Hamburger.module.scss";

export const Hamburger: FC = () => {
  const { mobileMenuOpen, setMobileMenuOpen } = useContext(HeaderContext) as IHeaderContext;

  return (
    <button
      type="button"
      className={classNames(s.Hamburger, {
        [s.IsActive]: mobileMenuOpen,
      })}
      onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
      aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
      aria-controls="menu"
      aria-expanded={mobileMenuOpen}
    >
      <div className={s.Slice} />
      <div className={s.Slice} />
      <div className={s.Slice} />
    </button>
  );
};
